import { render, staticRenderFns } from "./WorkingShift.vue?vue&type=template&id=bf8f4e0a"
import script from "./WorkingShift.vue?vue&type=script&lang=js"
export * from "./WorkingShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports